"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { Page } from "@/helpers/Types";
import { TimeWindow, TIME_WINDOW_MS } from "@/types/boosted-drops.types";
interface UseWaveBoostedDropsProps {
  readonly waveId: string;
  readonly limit?: number;
  readonly timeWindow?: TimeWindow;
}
const DEFAULT_LIMIT = 10;
const STALE_TIME = 60000; // 1 minute
const REFETCH_INTERVAL = 30000; // 30 seconds

export function useWaveBoostedDrops(t0) {
  const $ = _c(9);
  const {
    waveId,
    limit: t1,
    timeWindow: t2
  } = t0;
  const limit = t1 === undefined ? DEFAULT_LIMIT : t1;
  const timeWindow = t2 === undefined ? TimeWindow.DAY : t2;
  let t3;
  let t4;
  if ($[0] !== limit || $[1] !== timeWindow || $[2] !== waveId) {
    t3 = [QueryKey.BOOSTED_DROPS, {
      waveId,
      limit,
      timeWindow
    }];
    t4 = async () => {
      const countOnlyBoostsAfter = Date.now() - TIME_WINDOW_MS[timeWindow];
      const response = await commonApiFetch({
        endpoint: "boosted-drops",
        params: {
          wave_id: waveId,
          sort: "boosts",
          sort_direction: "DESC",
          page_size: limit.toString(),
          count_only_boosts_after: countOnlyBoostsAfter.toString()
        }
      });
      return response.data;
    };
    $[0] = limit;
    $[1] = timeWindow;
    $[2] = waveId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = !!waveId;
  let t6;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: STALE_TIME,
      refetchInterval: REFETCH_INTERVAL,
      retry: 2,
      retryDelay: _temp
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return useQuery(t6);
}
function _temp(attemptIndex) {
  return attemptIndex * 1000;
}